export function maskCnpj(value: string | undefined) {
  value = value + "";
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
  value = value.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
  value = value.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
  return value;
}

export function maskCnpjString() {
  return "##.###.###.####-##";
  // 07.290.290/0001-02
}


export function maskNuMatricula(value: string) {
  value = value + "";
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
  return value;
};

export function maskNuMatriculaOnExit(value: string) {
  // Remove all non-digit characters
  const digitsOnly = value.replace(/\D/g, '');
  if(digitsOnly.length === 0 || digitsOnly === '0')
    return

  // Pad with leading zeros if less than 5 digits
  const paddedValue = digitsOnly.padStart(5, '0');

  // Apply the mask "####-#"
  if (paddedValue.length > 4) {
    return `${paddedValue.substring(0, 4)}-${paddedValue.substring(4, 5)}`;
  }
  return paddedValue;
};


// export function maskNuMatricula(value: string) {
//   // Remove all non-digit characters
//   const digitsOnly = value.replace(/\D/g, '');

//   // Pad with leading zeros if less than 5 digits
//   const paddedValue = digitsOnly.padStart(5, '0');

//   // Apply the mask "####-#"
//   if (paddedValue.length > 4) {
//     return `${paddedValue.substring(0, 4)}-${paddedValue.substring(4, 5)}`;
//   }
//   return paddedValue;
// };

export function maskNuMatriculaString() {
  return "####-#";
}


export function maskCpf(value: string) {
  value = value + "";
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{3})(\d)/, "$1.$2"); //Coloca ponto entre o terceiro e o quarto dígitos
  value = value.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o sexto e o sétimo dígitos
  value = value.replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4"); //Coloca um hífen antes dos 2 dígitos verificadores
  return value;
};

export function maskCpfString() {
  return "###.###.###-##"
};

export function maskCodigo(value: string) {
  value = value + "";
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{4})(\d)/, "$1-$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  return value;
}

export function maskNumeroProcesso(value: string | undefined) {
  value = value + "";
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  if (value.length === 17) {
    value = value.replace(/^(\d{5})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
    value = value.replace(/^(\d{5})\.(\d{6})(\d)/, "$1.$2/$3"); //Coloca ponto entre o quinto e o sexto dígitos
    value = value.replace(/\/(\d{4})(\d)/, "/$1-$2"); //Coloca uma barra entre o oitavo e o nono dígitos
  }
  return value;
}

export function maskData(value: string) {
  value = value + "";
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{2})(\d)/, "$1/$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  value = value.replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3"); //Coloca ponto entre o quinto e o sexto dígitos
  return value;
}

export function maskCNPB(value: string) {
  value = value + "";
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{4})(\d{4})(\d)/, "$1.$2-$3"); //Coloca ponto entre o segundo e o terceiro dígitos
  return value;
}

export function maskCurrency(value: string | number): string {
  if (value === null || value === undefined) return "";

  // Keep only digits
  let digits = value.toString().replace(/\D/g, "");

  if (digits.length === 0) return "";

  // Case: only decimals typed (1 → 0,01 / 12 → 0,12)
  if (digits.length <= 2) {
    return "0," + digits.padStart(2, "0");
  }

  // Split into integer + decimal
  const decimal = digits.slice(-2);
  let integer = digits.slice(0, -2);

  //  Remove leading zeros ONLY if integer has more than 1 digit
  integer = integer.replace(/^0+(?=\d)/, "");

  // Add thousand separators
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return integer + "," + decimal;
}


export const numberOnly = (valor: string) => {
  return valor && typeof valor === "string"
    ? valor.replace(/([^\d])+/gim, "")
    : valor;
};

export function onlyNormalCaracteres(string: string | undefined) {
  return string?.replace(/[^0-9a-zA-Z]/g, "");
}

export const validacaoNumeroProcesso = (value: any) => {
  let v = value
    .replace(/_/g, "")
    .replace(/-/g, "")
    .replace(/\//g, "")
    .replace(/\./g, "");
  return v;
};

export const maskCep = (isValue: any) => {
  isValue = isValue + "";
  isValue = isValue.replace(/\D/g, ""); //Remove tudo o que não é dígito

  isValue = isValue.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  isValue = isValue.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2-$3"); //Coloca ponto entre o quinto e o sexto dígitos
  return isValue;
};

export const maskTelefone = (isValue: any) => {
  isValue = isValue + "";
  isValue = isValue.replace(/\D/g, ""); //Remove tudo o que não é dígito

  isValue = isValue.replace(/^(\d{0})(\d)/, `$1($2`); //Coloca ponto entre o segundo e o terceiro dígitos
  isValue = isValue.replace(/(\d{2})(\d)/, `$1) $2`); //Coloca ponto entre o segundo e o terceiro dígitos
  isValue = isValue.replace(/(\d{4})(\d)/, `$1-$2`); //Coloca ponto entre o segundo e o terceiro dígitos
  return isValue;
};
